import { FormEvent, useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { DefaultModal } from "../../common/modals/default-modal/default-modal";
import { ButtonWithSpinner } from "../../common/button-with-spinner/button-with-spinner";
import defaultStyles from "../../common/modals/default-modal/default-modal.less";
import { resources } from "@constants/hardcoded-strings";
import { ButtonTypes } from "@enums/button-types";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import { useDispatch } from "react-redux";
import { FormattedVerificationServiceConfiguration } from "@idw-types/data/verification-service-configuration";
import { EntityStatusTypes } from "@enums/entity-status-types";
import { replaceVerificationServiceConfiguration } from "@redux/actions/verification-services-actions";
import { ModalSizeTypes } from "@enums/modal-size-types";
import { restoreVerificationServiceRequest } from "@requests/service-configuration";

type RestoreVerificationServiceModalProps = {
    onModalClose: () => void;
    verificationServiceConfiguration: FormattedVerificationServiceConfiguration;
};

export const RestoreVerificationServiceModal = (props: RestoreVerificationServiceModalProps) => {
    const dispatch = useDispatch();
    const { onModalClose, verificationServiceConfiguration } = props;

    const [requestInProgress, setRequestInProgress] = useState(false);

    const handleSubmit = async (event: FormEvent) => {
        event.preventDefault();
        setRequestInProgress(true);
        const { data, error } = await restoreVerificationServiceRequest(verificationServiceConfiguration.id);
        if (data) {
            displaySuccessModal(
                dispatch,
                resources.requests.restoreVerificationService.success.title,
                resources.requests.restoreVerificationService.success.message
            );

            const newVerificationServiceConfiguration: FormattedVerificationServiceConfiguration = {
                ...verificationServiceConfiguration,
                permissions: {
                    ...verificationServiceConfiguration.permissions,
                    canArchive: true,
                    canRestore: false
                },
                status: EntityStatusTypes.ACTIVE
            };

            dispatch(replaceVerificationServiceConfiguration(newVerificationServiceConfiguration));
            onModalClose();
        } else {
            if (error) {
                logAndDisplayErrorModal(
                    dispatch,
                    error,
                    resources.requests.restoreVerificationService.error.title,
                    resources.requests.restoreVerificationService.error.message
                );
            }
            setRequestInProgress(false);
        }
    };

    return (
        <DefaultModal
            automationId="restore-verification-service-modal"
            ariaLabelledBy="restore-verification-service-title"
            onHide={onModalClose}
            backdrop={"static"}
            keyboard={false}
            isMaxWidth={false}
            size={ModalSizeTypes.MEDIUM}
        >
            <Form onSubmit={handleSubmit}>
                <Modal.Header id={"restore-verification-service-title"} closeButton>
                    <Modal.Title>{resources.modals.restoreVerificationService.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <span className={defaultStyles.description}>
                        {resources.modals.restoreVerificationService.description}
                    </span>
                </Modal.Body>
                <Modal.Footer>
                    <Button id="restore-verification-service-cancel" variant="secondary" onClick={onModalClose}>{resources.common.buttons.cancel.label}</Button>
                    <ButtonWithSpinner
                        id="restore-verification-service-submit"
                        disabled={requestInProgress}
                        hideSpinner={false}
                        variant="primary"
                        type={ButtonTypes.SUBMIT}
                        label={resources.modals.restoreVerificationService.buttons.proceed.label}
                    />
                </Modal.Footer>
            </Form>
        </DefaultModal>
    );
};